"use strict";

module.exports = function (instance, factory, properties) {
    if (!instance || !instance.setProperties) return factory.create(properties);
    instance.setProperties(properties);
    return instance;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/utils/recycle.js
 ** module id = 512
 ** module chunks = 0 1
 **/